import UF from './uf'

export default class Fornecedor {
  constructor(id, documento, nome, tipoFornecedor, conferido) {
    this.id = id
    this.documento = documento
    this.nome = nome
    this.uf = new UF()
    this.tipoFornecedor = tipoFornecedor
    this.conferido = conferido
  }
}
